import React from 'react';


const tecno = [
    { T: 'MySql', L: 'https://www.mysql.com/' },




];


class kanjabanbi extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>Kanjaban data base</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <div className="imageProyect imageKanjaban"></div>
                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>This database in MySql belongs to the kanjaban application.</p>

                        <a href="https://github.com/BrandonGrimaldoM/KanjabanDataBase" target="_blank" rel="noreferrer">
                            <button className="animateButtonGit"> <p>Repository </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default kanjabanbi;